import React from 'react';

export default function Hero() {
  return (
    <section className="hero is-primary">
      <div className="hero-body">
        <div className="container">
          <img src="casegraphics.png" alt="case analytics" />
        </div>
      </div>
    </section>
  )
}
